import {
  Badge,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Table
} from "reactstrap";
import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback
} from 'react'
import {
  clearDeviceListError,
  closeAssignDeviceModal,
  closeCreateDeviceModal,
  closeDevicesCycleModal,
  closeDevicesLogModal,
  deleteDevice,
  deviceDeleteError,
  exportData,
  exportLatestDevices,
  getDevicesList,
  getLatestDevices,
  openAssignDeviceModal,
  openCreateDeviceModal,
  openDevicesCycleModal,
  openDevicesLogModal,
  setDeviceId,
  setSelectedDevice
} from "../../store/device/actions";
import NoRecord from "../../CommonData/norecord/norecord";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Skeleton from "../../components/vwSkeleton/vwSkeleton"
import {
  ASSIGNED_STATUS_LIST,
  DELETED_STATUS_LIST,
  DEVICE_EXPORT_HEADERS,
  RETURNED_STATUS_LIST,
  STATUS_LIST
} from "../../store/device/actionTypes";
import {
  CUSTOMER,
  ORGANIZATION_ADMIN,
  RETAILER,
  SUPER_ADMIN,
  TECHNICIAN,
  MANUFACTURER,
  PROFILE_ROLES_LIST
} from "../../store/users/role.constants";
import { getPager } from "../../helper/common";
import VWPagination from "../../components/vwPagination/vwPagination";
import AssignDevice from "./AssignDevice";
import VWModel from "../../components/vwModal/vwModal";
import { excelPrint } from "../../helper/export";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import debounce from "lodash/debounce";
import moment from 'moment'
import UITooltip from "../../CommonData/Data/UITooltip";
import "../FixedColumn.css";
import Swal from "../../CommonData/Data/Swal";
import VWOffCanvas from "../../components/vwModal/vwOffCanvas";
import DeviceLifeCycle from "./devicleLifeCycle";
import DevicleLog from "./devicleLog";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const DeviceList = (props) => {

  const { deviceList, isGetDevicePending, errorMessage, isAssignDeviceModalOpen, currentProfile, isAssignSuccess, deviceDeleteErrorMessage,
    isDeviceLifeCycleModalOpen, isDeviceLogModalOpen } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });
  const [filter, setFilter] = useState();
  const [filterDisplay, setFilterDisplay] = useState();
  const [latestExport, setLatestExport] = useState(false);
  const [dropdownOpen, setOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [roleFilter, setRoleFilter] = useState();

  const [swalOptions, setSwalOptions] = useState({
    title: "Are you sure?",
    text: "Do you want to delete the selected devices?",
    icon: "warning",
    buttons: {
      cancel: true,
      confirm: {
        text: "Yes, delete it!",
        value: true,
        visible: true,
        className: "bg-danger",
        closeModal: true,
      },
    },
  });

  const navigate = useNavigate();
  const location = useLocation();
  const assignedDevice = location.state || null;
  const { activeStatus, assignedStatus } = assignedDevice || {};

  //--------------------------------Navigation--------------------------------------

  const navigateForMDCustomer = (e) => {
    e.preventDefault();
    navigate('/devicelist/master-devices-customers')
  }
  const navigateForMDRetailer = (e) => {
    e.preventDefault();
    navigate('/devicelist/master-devices')
  }

  //-----------------------ROLES------------------------------------------------
  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);
  const isRetailer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === RETAILER;
  const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === SUPER_ADMIN;
  const isOrgAdmin = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN;
  const isEndUser = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === CUSTOMER;
  const isTechnician = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === TECHNICIAN;
  const isManufacturer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === MANUFACTURER;

  //-----------------------FILTER------------------------------------------------
  const buildQueryDeviceKey = () => {
    const { deviceKey } = filter || {};
    let searchDeviceKey = '';
    if (deviceKey) {
      searchDeviceKey += `${deviceKey}`;
    }
    return searchDeviceKey
  }
  const buildQueryUid = () => {
    const { uid } = filter || {};
    let searchUid = '';
    if (uid) {
      searchUid += `${uid}`;
    }
    return searchUid
  }
  const buildQueryModelNo = () => {
    const { modelNo } = filter || {};
    let searchModelNo = '';
    if (modelNo) {
      searchModelNo += `${modelNo}`;
    }
    return searchModelNo
  }

  const buildQueryName = () => {
    const { name } = filter || {};
    let searchName = '';
    if (name) {
      searchName += `${name}`;
    }
    return searchName
  }

  const buildQueryIsReturned = () => {
    const { isReturned } = filter || {};
    let searchIsReturned = '';
    if ((isReturned !== null) && (isReturned !== undefined)) {
      searchIsReturned += `${isReturned}`;
    }
    return searchIsReturned
  }

  const buildQueryHardwareVersion = () => {
    const { hardwareVersion } = filter || {};
    let searchHardwareVersion = '';
    if (hardwareVersion) {
      searchHardwareVersion += `${hardwareVersion}`;
    }
    return searchHardwareVersion
  }

  const buildQueryFirmwareVersion = () => {
    const { firmwareVersion } = filter || {};
    let searchFirmwareVersion = '';
    if (firmwareVersion) {
      searchFirmwareVersion += `${firmwareVersion}`;
    }
    return searchFirmwareVersion
  }

  const buildQueryOrgName = () => {
    const { orgName } = filter || {};
    let searchOrgName = '';
    if (orgName) {
      searchOrgName += `${orgName}`;
    }
    return searchOrgName
  }

  const buildQueryAssignedByUserEmail = () => {
    const { assignedByUserEmail } = filter || {};
    let searchAssignedByUserEmail = '';
    if (assignedByUserEmail) {
      searchAssignedByUserEmail += `${assignedByUserEmail.replace(/\+/g, "%2B")}`;
    }
    return searchAssignedByUserEmail
  }
  const buildQueryAssignedUserDisplayName = () => {
    const { assignedUserDisplayName } = filter || {};
    let searchAssignedUserDisplayName = '';
    if (assignedUserDisplayName) {
      searchAssignedUserDisplayName += `${assignedUserDisplayName}`;
    }
    return searchAssignedUserDisplayName
  }

  const buildQueryAssignedUserEmail = () => {
    const { assignedUserEmail } = filter || {};
    let searchAssignedUserEmail = '';
    if (assignedUserEmail) {
      searchAssignedUserEmail += `${assignedUserEmail.replace(/\+/g, "%2B")}`;
    }
    return searchAssignedUserEmail
  }
  const buildQueryAssignedUserRoleName = () => {
    const { assignedUserRoleName } = filter || {};
    let searchAssignedUserRoleName = '';
    if (assignedUserRoleName) {
      searchAssignedUserRoleName += `${assignedUserRoleName}`;
    }
    return searchAssignedUserRoleName
  }

  const buildQueryIsAssigned = () => {
    const { isAssigned } = filter || {};
    let searchIsAssigned = '';
    if ((isAssigned !== null) && (isAssigned !== undefined)) {
      searchIsAssigned += `${isAssigned}`;
    }
    return searchIsAssigned
  }

  const buildQueryIsActive = () => {
    const { isActive } = filter || {};
    let searchIsActive = '';
    if ((isActive !== null) && (isActive !== undefined)) {
      searchIsActive += `${isActive}`;
    }
    return searchIsActive
  }

  const buildQueryIsDeleted = () => {
    const { isDeleted } = filter || {};
    let searchIsDeleted = '';
    if ((isDeleted !== null) && (isDeleted !== undefined)) {
      searchIsDeleted += `${isDeleted}`;
    }
    return searchIsDeleted
  }

  const buildQueryEndCustomerName = () => {
    const { endCustomerName } = filter || {};
    let searchEndCustomerName = '';
    if (endCustomerName) {
      searchEndCustomerName += `${endCustomerName}`;
    }
    return searchEndCustomerName
  }

  const buildQueryEndCustomerEmail = () => {
    const { endCustomerEmail } = filter || {};
    let searchEndCustomerEmail = '';
    if (endCustomerEmail) {
      searchEndCustomerEmail += `${endCustomerEmail.replace(/\+/g, "%2B")}`;
    }
    return searchEndCustomerEmail
  }

  const buildQueryRoomName = () => {
    const { roomName } = filter || {};
    let searchroomName = '';
    if (roomName) {
      searchroomName += `${roomName}`;
    }
    return searchroomName
  }
  const buildQueryCreatedDateTime = () => {
    const { createdDateTime } = filter || {};
    let searchCreatedDateTime = '';
    if (createdDateTime) {
      searchCreatedDateTime += `${createdDateTime}`;
    }
    return searchCreatedDateTime
  }

  const setPage = (page = 1) => {
    if (latestExport) {
      props.getLatestDevices(page, pageSize, buildQueryDeviceKey(), buildQueryUid(), buildQueryModelNo(), buildQueryName(), buildQueryIsReturned(), buildQueryHardwareVersion(),
        buildQueryFirmwareVersion(), buildQueryOrgName(), buildQueryAssignedUserDisplayName(), buildQueryAssignedUserEmail(), buildQueryAssignedUserRoleName(),
        buildQueryIsAssigned(), buildQueryIsActive(), buildQueryIsDeleted(), buildQueryEndCustomerName(), buildQueryEndCustomerEmail(), buildQueryRoomName(),
        buildQueryCreatedDateTime(), sortDirection, sortOrder);
    }
    else {
      props.getDevicesList(page, pageSize, buildQueryDeviceKey(), buildQueryUid(), buildQueryModelNo(), buildQueryName(), buildQueryIsReturned(), buildQueryHardwareVersion(),
        buildQueryFirmwareVersion(), buildQueryOrgName(), buildQueryAssignedByUserEmail(), buildQueryAssignedUserDisplayName(), buildQueryAssignedUserEmail(),
        buildQueryAssignedUserRoleName(), buildQueryIsAssigned(), buildQueryIsActive(), buildQueryIsDeleted(), buildQueryEndCustomerName(), buildQueryEndCustomerEmail(),
        buildQueryRoomName(), buildQueryCreatedDateTime(), sortDirection, sortOrder);
    }
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecordsCount / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };

  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecordsCount, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecordsCount, pageSize]);

  useEffect(() => {
    if (assignedDevice) {
      setFilter({
        ...filter,
        isAssigned: assignedStatus ? assignedStatus === 'assigned' ? true : false : null,
        isActive: activeStatus ? activeStatus === 'active' ? true : false : null,
      })
      setFilterDisplay({
        ...filterDisplay,
        isAssigned: assignedStatus ? assignedStatus === 'assigned' ? true : false : null,
        isActive: activeStatus ? activeStatus === 'active' ? true : false : null,
      })
    }
    else {
      setPage();
    }
    props.deviceDeleteError();
    props.clearDeviceListError()
  }, [isAssignSuccess, pageSize]);

  const sendBackendRequest = useCallback((name, value) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }, []);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendBackendRequest, 1000);
  }, [sendBackendRequest]);

  const searchInputValidation = (event) => {
    const input = event.target;
    const { value, name } = input;
    debouncedSendRequest(name, value)
    setFilterDisplay({
      ...filterDisplay,
      [name]: value
    });
  }
  const filterAvailableDevices = () => {
    const name = "isDeleted";
    const value = false;
    debouncedSendRequest(name, value)
    setFilterDisplay({
      ...filterDisplay,
      [name]: value
    });
  }
  const clearAvailableFilter = () => {
    const name = "isDeleted";
    const value = "";
    debouncedSendRequest(name, value)
    setFilterDisplay({
      ...filterDisplay,
      [name]: value
    });
  }

  const handleSearchClick = () => {
    setPage();
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  useEffect(() => {
    if (filter) {
      handleSearchClick();
    }
  }, [filter])

  //-----------------------ROLES DROPDOWN-----------------------------------------
  useEffect(() => {
    const currentProfileRoles = props.currentProfile.roles || [];
    const relevantUserRoles = currentProfileRoles.length > 0 ? PROFILE_ROLES_LIST.filter((role) =>
      role.roleLevel >= currentProfileRoles[0].rank) : [];
    setRoleFilter(relevantUserRoles)
  }, [])
  //-----------------------SORTING------------------------------------------------

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])
  //-----------------------EXPORT------------------------------------------------

  const handleExportDevices = () => {
    const { exportData, currentProfile } = props;
    exportData().then((responseData) => {
      if (responseData) {
        let headers = DEVICE_EXPORT_HEADERS;
        let exportedData = [];
        let headerSizes;

        responseData.forEach((element) => {
          exportedData.push({
            deviceKey: element.deviceKey,
            uid: element.uid || "NA",
            modelNo: element.modelNo || "NA",
            name: element.name || "NA",
            isReturned: element.isReturned ? "Returned" : "New",
            hardwareVersion: element.hardwareVersion || "NA",
            firmwareVersion: element.firmwareVersion || "NA",
            orgName: element.orgName || "NA",
            createdDateTime: element.createdDateTime ? moment(element.createdDateTime).format("DD/MM/YYYY") : "NA",
            assignedByUserName: element.assignedByUserName || "NA",
            assignedByUserEmail: element.assignedByUserEmail || "NA",
            assignedUserDisplayName: element.assignedUserDisplayName || "NA",
            assignedUserEmail: element.assignedUserEmail || "NA",
            assignedUserRoleName: element.assignedUserRoleName || "NA",
            isAssigned: element.isAssigned ? "Assinged" : "Unassigned",
            isActive: element.isActive ? "Active" : "Inactive",
            isDeleted: element.isDeleted ? "Deleted" : "Available",
            roomName: element.roomName || "NA",
            endCustomerName: element.endCustomerName || "NA",
            endCustomerEmail: element.endCustomerEmail || "NA",
            subscriptionValidate: element.subscriptionValidate ? moment(element.subscriptionValidate).format("DD/MM/YYYY") : "NA",
            amcStartDate: element.amcStartDate ? moment(element.amcStartDate).format("DD/MM/YYYY") : "NA",
            amcEndDate: element.amcEndDate ? moment(element.amcEndDate).format("DD/MM/YYYY") : "NA",
            amcStatus: element.amcStatus || "NA",
          });
        });

        if ((isManufacturer || isSuperAdmin)) {
          exportedData = exportedData.filter(function (v) {
            delete v.orgName;
            delete v.roomName;
            delete v.assignedByUserName;
            delete v.assignedByUserEmail;
            delete v.endCustomerName;
            delete v.endCustomerEmail;
            return true;
          });
          headers = headers.filter(
            (e) =>
              !(
                e === "ASSIGNED BY USER" ||
                e === "ASSIGNED BY USER EMAIL" ||
                e === "CUSTOMER NAME" ||
                e === "CUSTOMER EMAIL" ||
                e === "ROOM NAME" ||
                e === "ORGANIZATION"
              )
          );
          headerSizes = [20, 30, 20, 20, 20, 10, 10, 20, 30, 50, 30, 30, 20, 20, 30, 30, 30, 20]
        }

        else if (!(isRetailer || isEndUser)) {
          exportedData = exportedData.filter(function (v) {
            delete v.orgName
            delete v.roomName
            delete v.endCustomerName;
            delete v.endCustomerEmail;
            delete v.isDeleted;
            return true;
          });
          headers = headers.filter(
            (e) =>
              !(
                e === "CUSTOMER NAME" ||
                e === "CUSTOMER EMAIL" ||
                e === "ROOM NAME" ||
                e === "ORGANIZATION" ||
                e === "DELETED STATUS"
              )
          );
          headerSizes = [20, 30, 20, 20, 20, 10, 10, 20, 30, 50, 30, 50, 30, 20, 20, 30, 20, 20, 20]
        }

        else if ((isRetailer || isEndUser)) {
          exportedData = exportedData.filter(function (v) {
            delete v.orgName
            delete v.assignedUserDisplayName;
            delete v.assignedUserEmail;
            delete v.assignedUserRoleName;
            delete v.isDeleted;
            return true;
          });
          headers = headers.filter(
            (e) =>
              !(
                e === "ASSIGNED TO USER" ||
                e === "ASSIGNED TO USER EMAIL" ||
                e === "ASSIGNED TO USER ROLE" ||
                e === "ORGANIZATION" ||
                e === "DELETED STATUS"
              )
          );
          headerSizes = [20, 20, 20, 20, 20, 20, 20, 20, 40, 50, 20, 20, 30, 40, 50, 30, 20, 20, 20]
        }
        else {
          return null;
        }
        excelPrint(exportedData, "Device-List", headers, headerSizes);
      }
    })
  };

  const handleAssignDeviceClose = () => {
    const { closeAssignDeviceModal } = props;
    closeAssignDeviceModal();
  };

  const handleAssignDevices = () => {
    const { openAssignDeviceModal } = props;
    openAssignDeviceModal();
  };
  const canShowAssignDevice = !(isEndUser || isTechnician || isRetailer || isSuperAdmin);

  const handleLatestDevices = () => {
    setLatestExport(!latestExport);

    if (!latestExport) {
      props.getLatestDevices();
      setFilter();
      setFilterDisplay();
    }
    else {
      props.getDevicesList();
      setFilter()
      setFilterDisplay();
    }
  }
  const exportLatestDevices = () => {
    props.exportLatestDevices().then((responseData) => {
      if (responseData) {
        let headers = DEVICE_EXPORT_HEADERS;
        let exportedData = [];
        let headerSizes;
        responseData.forEach((element) => {
          exportedData.push({
            deviceKey: element.deviceKey || "NA",
            uid: element.uid || "NA",
            modelNo: element.modelNo || "NA",
            name: element.name || "NA",
            isReturned: element.isReturned ? "Returned" : "New",
            hardwareVersion: element.hardwareVersion || "NA",
            firmwareVersion: element.firmwareVersion || "NA",
            orgName: element.orgName || "NA",
            createdDateTime: element.createdDateTime ? moment(element.createdDateTime).format("DD/MM/YYYY") : "NA",
            assignedByUserName: element.assignedByUserName || "NA",
            assignedUserDisplayName: element.assignedUserDisplayName || "NA",
            assignedByUserEmail: element.assignedByUserEmail || "NA",
            assignedUserEmail: element.assignedUserEmail || "NA",
            assignedUserRoleName: element.assignedUserRoleName || "NA",
            isAssigned: element.isAssigned ? "Assinged" : "Unassigned",
            isActive: element.isActive ? "Active" : "Inactive",
            isDeleted: element.isDeleted ? "Deleted" : "Available",
            roomName: element.roomName || "NA",
            subscriptionValidate: element.subscriptionValidate ? moment(element.subscriptionValidate).format("DD/MM/YYYY") : "NA",
            amcStartDate: element.amcStartDate ? moment(element.amcStartDate).format("DD/MM/YYYY") : "NA",
            amcEndDate: element.amcEndDate ? moment(element.amcEndDate).format("DD/MM/YYYY") : "NA",
            amcStatus: element.amcStatus || "NA",
          });
        });
        if ((isManufacturer || isSuperAdmin)) {
          exportedData = exportedData.filter(function (v) {
            delete v.orgName;
            delete v.roomName;
            delete v.assignedByUserName;
            delete v.assignedByUserEmail;
            delete v.endCustomerName;
            delete v.endCustomerEmail;
            return true;
          });
          headers = headers.filter(
            (e) =>
              !(
                e === "ASSIGNED BY USER" ||
                e === "ASSIGNED BY USER EMAIL" ||
                e === "CUSTOMER NAME" ||
                e === "CUSTOMER EMAIL" ||
                e === "ROOM NAME" ||
                e === "ORGANIZATION"
              )
          );
          headerSizes = [20, 30, 20, 20, 20, 10, 10, 20, 30, 50, 30, 30, 20, 20, 30, 30, 30, 20]
        }
        else {
          return null;
        }
        excelPrint(exportedData, "Latest-Device-List", headers, headerSizes);
      }
    });
  }

  //----------------------------DELETE--------------------------------------
  const handleSelectDevice = (e, deviceKey) => {
    const { checked } = e.target || {};
    const deviceTobeDeleted = [...selectedDevice];
    if (checked) {
      deviceTobeDeleted.push(deviceKey);
    }
    else {
      const isPresent = deviceTobeDeleted.findIndex((device) => device === deviceKey);
      deviceTobeDeleted.splice(isPresent, 1);
    }
    setSelectedDevice(deviceTobeDeleted);
  }
  const removeDeviceCallBack = (isConfirm,) => {
    const { deleteDevice } = props;
    if (isConfirm) {
      deleteDevice(selectedDevice)
        .then((response) => {
          const { isDeviceDeleted, deletedDevices } = response || {}
          if (isDeviceDeleted) {
            setIsDelete(false);
          }
          const devicesArr = [...selectedDevice];
          const reducedArr = devicesArr?.filter(element => !deletedDevices?.includes(element?.toString()));
          setSelectedDevice(reducedArr);
          setPage();
        })
    }
  };
  //----------------------------DEVICE CYCLE--------------------------------------
  const handleDevicesCycleOpen = (id) => {
    props.setDeviceId(id);
    props.openDevicesCycleModal();
  };

  const handleDevicesCycleClose = () => {
    props.closeDevicesCycleModal();
  };
  //----------------------------DEVICE LOG----------------------------------------
  const handleDevicesLogOpen = (selectedDevice) => {
    props.setSelectedDevice(selectedDevice);
    props.openDevicesLogModal();
  };

  const handleDevicesLogClose = () => {
    props.closeDevicesLogModal();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
            DEVICES
            <div className="content-heading">
              {!isDelete ? (
                <div className="ml-auto">
                  {(isManufacturer) && (
                    <Link
                      type="button"
                      className="me-1 btn btn-primary btn-sm"
                      to="add"
                    >
                      <em className="fas fa-plus me-2" />Create Device
                    </Link>
                  )}
                  {(isEndUser || isAdmin) && (
                    <Link
                      type="button"
                      className="btn btn-primary btn-sm me-1"
                      to="/devicelist/master-devices"
                    >
                      <em className="fas fa-sign-in-alt me-2" />View Master Devices
                    </Link>
                  )}
                  {isRetailer && (
                    <ButtonDropdown toggle={() => { setOpen(!dropdownOpen) }}
                      isOpen={dropdownOpen}>
                      <Button
                        className="btn-oval"
                        color='primary'
                        size='sm'
                        onClick={() => { setOpen(!dropdownOpen) }}
                      ><em className="fas fa-sign-in-alt me-2" />View Master Devices
                      </Button>
                      <DropdownToggle
                        color='primary'
                        split
                        className='px-2 me-2'
                        size='sm'
                      >
                        {dropdownOpen ? <i class="fas fa-caret-down" />
                          : <i class="fas fa-caret-up" />
                        }
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={navigateForMDRetailer}>
                          Created By Retailer
                        </DropdownItem>
                        <DropdownItem onClick={navigateForMDCustomer}>
                          Created By Customer
                        </DropdownItem>
                      </DropdownMenu>
                    </ButtonDropdown>
                  )}
                  {canShowAssignDevice && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm me-1"
                      onClick={handleAssignDevices}
                    >
                      <em className="fas fa-paste me-2" /> Assign Device
                    </button>
                  )}
                  {isManufacturer &&
                    <Button
                      size="sm"
                      color="danger"
                      className="me-1"
                      onClick={() => {
                        filterAvailableDevices();
                        setIsDelete(true);
                      }}
                    >
                      <em className="fas fa-trash-alt me-2" />Delete Device
                    </Button>
                  }
                  <button
                    type="button"
                    className="me-1 btn btn-primary btn-sm"
                    onClick={handleExportDevices}
                  >
                    <em className="fas fa-download me-2" />Export
                  </button>
                </div>)
                :
                <div className="d-flex gap-1">
                  <UITooltip id="confirmDelete" content={selectedDevice?.length === 0 ? "Select atleast one device to delete" : null}>
                    <Swal
                      options={selectedDevice?.length !== 0 && swalOptions}
                      callback={(p, swal) => removeDeviceCallBack(p, swal, selectedDevice)}
                    >
                      <Button
                        size="sm"
                        color="danger"
                        className="me-1"
                        disabled={selectedDevice?.length === 0}
                      >
                        <em className="fas fa-trash-alt me-2" /> Confirm Delete
                      </Button>
                    </Swal>
                  </UITooltip>
                  <Button
                    size="sm"
                    className="me-1 btn-secondary active"
                    onClick={() => {
                      setIsDelete(false);
                      props.deviceDeleteError();
                      setSelectedDevice([]);
                      clearAvailableFilter();
                    }}
                  >
                    <em className="fas fa-times me-2" />Cancel
                  </Button>
                </div>
              }
            </div>
          </CardTitle>
        </Card>
        <Card>
          <div className="d-flex justify-content-end pt-2 pe-2 gap-2">
            {latestExport &&
              <div className="d-flex gap-1">
                {((deviceList && deviceList.length > 0) && deviceList[0].createdDateTime) &&
                  <div className="d-flex gap-2 align-items-center">
                    <UITooltip id="createdDate" content="Created Date">
                      <Badge id="createdDate" color="info" className="p-1">
                        <span className="mdi mdi-calendar-month-outline me-1" />
                        {moment(deviceList && deviceList[0].createdDateTime).format("DD/MM/YYYY")}
                      </Badge>
                    </UITooltip>
                    <UITooltip id="createdTime" content="Created Time">
                      <Badge id="createdTime" color="success" className="p-1">
                        <span className="mdi mdi-clock-time-three-outline me-1" />
                        {moment(deviceList && deviceList[0].createdDateTime).format("hh:mm:ss")}
                      </Badge>
                    </UITooltip>
                  </div>}
                <Button color="primary" size="sm" onClick={exportLatestDevices}>
                  Export
                </Button>
              </div>
            }
            {(isManufacturer && !isDelete) &&
              <Button
                color={latestExport ? "danger" : "primary"}
                size="sm"
                onClick={handleLatestDevices}
                disabled={isGetDevicePending}>
                {!latestExport ? "Latest Devices" : "Cancel"}
              </Button>}
          </div>
          <CardBody>
            {errorMessage && (
              <Message
                type="danger"
                defaultMessage={errorMessage}
                baseClassName="alert"
              />
            )}
            {deviceDeleteErrorMessage && (
              <Message
                type="danger"
                defaultMessage={deviceDeleteErrorMessage}
                baseClassName="alert"
              />
            )}
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-striped table-hover table-nowrap w-100" size='sm' style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                  <tr>
                    {isDelete &&
                      <th className="text-center sticky-column-cb" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "30" }}>
                        SELECT
                      </th>
                    }
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('deviceKey')}>
                      SERIAL #
                      {sortOrder === 'deviceKey' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer", minWidth: "80px" }} onClick={() => handleSort('uid')}>
                      UID
                      {sortOrder === 'uid' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer", minWidth: "80px" }} onClick={() => handleSort('modelNo')}>
                      MODEL #
                      {sortOrder === 'modelNo' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer", minWidth: "80px" }} onClick={() => handleSort('name')}>
                      PRODUCT  NAME
                      {sortOrder === 'name' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer", minWidth: "80px" }} onClick={() => handleSort('isReturned')}>
                      DEVICE CATEGORY
                      {sortOrder === 'isReturned' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('hardwareVersion')}>
                      H | F VERSION
                      {sortOrder === 'hardwareVersion' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    {(isSuperAdmin || isManufacturer) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('orgName')}>
                        ORGANIZATION
                        {sortOrder === 'orgName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                      CREATED ON
                      {sortOrder === 'createdDateTime' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    {!(isManufacturer || isSuperAdmin) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('assignedByUserName')}>
                        ASSIGNED BY USER
                        {sortOrder === 'assignedByUserName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    {!(isRetailer || isEndUser) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('assignedUserDisplayName')}>
                        ASSIGNED TO USER
                        {sortOrder === 'assignedUserDisplayName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    {!(isRetailer || isEndUser) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('assignedUserRoleName')}>
                        ASSIGNED TO USER ROLE
                        {sortOrder === 'assignedUserRoleName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('isAssigned')}>
                      ASSIGN STATUS
                      {sortOrder === 'isAssigned' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('isActive')}>
                      ACTIVE STATUS
                      {sortOrder === 'isActive' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                    </th>
                    {(isSuperAdmin || isManufacturer) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('isDeleted')}>
                        DELETED STATUS
                        {sortOrder === 'isDeleted' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    {(isRetailer || isEndUser) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('roomName')}>
                        ROOM NAME
                        {sortOrder === 'roomName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    {(isRetailer || isEndUser) && (
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('endCustomerEmail')}>
                        CUSTOMER NAME
                        {sortOrder === 'endCustomerEmail' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                      </th>
                    )}
                    {!isDelete &&
                      <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                        VIEW
                      </th>
                    }
                  </tr>
                  <tr>
                    {isDelete && (
                      <th className="sticky-column-cb" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "30" }}> </th>
                    )}
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          type='number'
                          size='sm'
                          placeholder="Search"
                          name="deviceKey"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.deviceKey) || " "}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          type='text'
                          size='sm'
                          placeholder="Search"
                          name="uid"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.uid) || ""}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          type='text'
                          size='sm'
                          placeholder="Search"
                          name="modelNo"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.modelNo) || ""}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          size='sm'
                          placeholder="Search"
                          name="name"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.name) || ""}
                        />
                      </FormGroup>
                    </th>
                    <th className="text-center">
                      <FormGroup>
                        <Input
                          type='select'
                          className="form-control"
                          size="sm"
                          name='isReturned'
                          placeholder="Select"
                          onChange={searchInputValidation}
                          value={filterDisplay ? filterDisplay.isReturned : ""}
                        >
                          <option value="" >Select</option>
                          {RETURNED_STATUS_LIST && RETURNED_STATUS_LIST.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          size='sm'
                          placeholder="Search"
                          name="hardwareVersion"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.hardwareVersion) || ""}
                        />
                      </FormGroup>
                    </th>
                    {(isSuperAdmin || isManufacturer) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            size='sm'
                            placeholder="Search"
                            name="orgName"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.orgName) || ""}
                          />
                        </FormGroup>
                      </th>
                    )}
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          size='sm'
                          type="date"
                          placeholder="Search"
                          name="createdDateTime"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={(filterDisplay && filterDisplay.createdDateTime) || ""}
                        />
                      </FormGroup>
                    </th>
                    {!(isSuperAdmin || isManufacturer) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            size='sm'
                            placeholder="Search"
                            name="assignedByUserEmail"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.assignedByUserEmail) || ""}
                          />
                        </FormGroup>
                      </th>
                    )}
                    {!(isRetailer || isEndUser) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            size='sm'
                            placeholder="Search"
                            name="assignedUserEmail"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.assignedUserEmail) || ""}
                          />
                        </FormGroup>
                      </th>
                    )}
                    {!(isRetailer || isEndUser) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            type="select"
                            size='sm'
                            placeholder="Search"
                            name="assignedUserRoleName"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.assignedUserRoleName) || ""}
                          >
                            <option value="" >Select</option>
                            {roleFilter && roleFilter.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </th>
                    )}
                    <th className="text-center">
                      <FormGroup>
                        <Input
                          type='select'
                          className="form-control"
                          size="sm"
                          name='isAssigned'
                          placeholder="Select"
                          onChange={searchInputValidation}
                          value={filterDisplay ? filterDisplay.isAssigned : ""}
                        >
                          <option value="" >Select</option>
                          {ASSIGNED_STATUS_LIST && ASSIGNED_STATUS_LIST.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </th>
                    <th className="text-center">
                      <FormGroup>
                        <Input
                          type='select'
                          className="form-control"
                          size='sm'
                          name='isActive'
                          placeholder="Select"
                          onChange={searchInputValidation}
                          value={filterDisplay ? filterDisplay.isActive : ""}
                        >
                          <option value="" >Select</option>
                          {STATUS_LIST && STATUS_LIST.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </th>
                    {(isSuperAdmin || isManufacturer) && (
                      <th className="text-center">
                        <FormGroup>
                          <Input
                            type='select'
                            className="form-control"
                            size='sm'
                            name='isDeleted'
                            placeholder="Select"
                            onChange={searchInputValidation}
                            value={filterDisplay ? filterDisplay.isDeleted : ""}
                            disabled={isDelete}
                          >
                            <option value="" >Select</option>
                            {DELETED_STATUS_LIST && DELETED_STATUS_LIST.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </th>
                    )}
                    {(isRetailer || isEndUser) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            size='sm'
                            placeholder="Search"
                            name="roomName"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.roomName) || ""}
                          />
                        </FormGroup>
                      </th>
                    )}
                    {(isRetailer || isEndUser) && (
                      <th>
                        <FormGroup>
                          <Input
                            className="form-control"
                            size='sm'
                            placeholder="Search"
                            name="endCustomerEmail"
                            onChange={searchInputValidation}
                            onKeyPress={handleKeypress}
                            value={(filterDisplay && filterDisplay.endCustomerEmail) || ""}
                          />
                        </FormGroup>
                      </th>
                    )}
                    {!isDelete &&
                      <th className="sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}></th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {(deviceList && deviceList.length > 0) && !isGetDevicePending ?
                    deviceList.map((data, index) => (
                      <tr key={index}>
                        {isDelete &&
                          <td align="center" className="text-center sticky-column-cb bg-white">
                            <FormGroup>
                              <Input
                                type="checkbox"
                                onChange={(e) => handleSelectDevice(e, data.deviceKey)}
                                defaultChecked={selectedDevice?.filter((key) => data.deviceKey === key)?.length > 0}
                              />
                            </FormGroup>
                          </td>
                        }
                        <td align="center">{data.deviceKey || "NA"}</td>
                        <td align="center">
                          <div className="d-flex gap-1">
                            {data.uid || "NA"}
                            <div>
                              {!data.warningMessage.every(item => item === null) &&
                                <UITooltip id={`warning-${index}`} content={data.warningMessage?.map((i) => { return i })}>
                                  <i class="fas fa-exclamation-triangle text-danger" style={{ cursor: "pointer" }} />
                                </UITooltip>
                              }
                            </div>
                          </div>
                        </td>
                        <td align="center">{data.modelNo || "NA"}</td>
                        <td>{data.name || "NA"}
                          {data.deviceTypeFlag && (
                            <Fragment>&nbsp;
                              <sup>
                                <UITooltip id={`masterdevice${index}`} content="Master Device">
                                  <Badge color='primary'>
                                    {data.deviceTypeFlag}
                                  </Badge>
                                </UITooltip>
                              </sup>
                            </Fragment>
                          )}
                        </td>
                        <td>
                          {data.isReturned ? (
                            <Badge color="danger">Returned</Badge>
                          ) : (<Badge color="success">New</Badge>)}
                        </td>
                        <td align="center">{data.hardwareVersion || "NA"} | {data.firmwareVersion || "NA"}</td>
                        {(isSuperAdmin || isManufacturer) && <td>{data.orgName || "NA"}</td>}
                        <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                        {!(isSuperAdmin || isManufacturer) &&
                          <td>
                            {data.assignedByUserName || "NA"}<br />
                            <small> {data.assignedByUserEmail || "NA"}</small>
                          </td>}
                        {!(isRetailer || isEndUser) && (
                          <Fragment>
                            <td>
                              {data.assignedUserDisplayName || "NA"}{" "}
                              <br />
                              <small>{data.assignedUserEmail || "NA"}</small></td>
                          </Fragment>
                        )}
                        {!(isRetailer || isEndUser) && (
                          <td>
                            {data.assignedUserRoleName || "NA"}
                          </td>
                        )}
                        <td>
                          {data.isAssigned ? (
                            <Badge color="success">Assigned</Badge>
                          ) : (<Badge color="danger"> Unassigned</Badge>)}
                        </td>
                        <td>
                          {data.isActive ? (
                            <Badge color="success">Active</Badge>
                          ) : (<Badge color="danger">Inactive</Badge>)}
                        </td>
                        {(isSuperAdmin || isManufacturer) && (
                          <td>
                            {data.isDeleted ? (
                              <Badge color="danger">Deleted</Badge>
                            ) : (<Badge color="success">Available</Badge>)}
                          </td>
                        )}
                        {(isRetailer || isEndUser) && (
                          <Fragment>
                            <td>{data.roomName || "NA"}</td>
                            <td>{data.endCustomerName || "NA"} <br />
                              <small> {data.endCustomerEmail || "NA"}</small>
                            </td>
                          </Fragment>
                        )}
                        {!isDelete &&
                          <td className="text-center sticky-column bg-white">
                            <UITooltip id={`details-${data.id}`} content="Device Details">
                              <Link
                                type="button"
                                className="btn btn-sm btn-light me-2"
                                to={`/devicelist/details/${data.id}`}
                              >
                                <em className="far fa-share-square"></em>
                              </Link>
                            </UITooltip>
                            <UITooltip id={`cycle-${data.id}`} content="Device Cycle">
                              <Button
                                size="sm"
                                className="me-2"
                                color="light"
                                onClick={() => { handleDevicesCycleOpen(data.id) }}
                              >
                                <i class="fas fa-recycle"></i>
                              </Button>
                            </UITooltip>
                            {(isAdmin || isManufacturer) &&
                              <UITooltip id={`log-${data.id}`} content="Device Log">
                                <Button
                                  size="sm"
                                  color="light"
                                  onClick={() => { handleDevicesLogOpen(data) }}
                                >
                                  <i class="mdi mdi-math-log"></i>
                                </Button>
                              </UITooltip>
                            }
                          </td>
                        }
                      </tr>
                    )) : isGetDevicePending ? (
                      <tr>
                        <td colSpan={15} align="center" className="p-4">
                          <Skeleton type="body" />
                          <VWLoading />
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={15}>
                          <NoRecord />
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
            </div>
          </CardBody>
          <CardFooter>
            {props.deviceList && props.deviceList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecordsCount}
                pageSize={pageSize}
                setPageSize={setPageSize}
              />
              : null
            }
          </CardFooter>
        </Card>
        <VWModel
          header="ASSIGN DEVICES"
          isOpen={isAssignDeviceModalOpen}
          handleClose={handleAssignDeviceClose}
        >
          <AssignDevice
            handleClose={handleAssignDeviceClose}
            filterData={filter}
          />
        </VWModel>
        <VWOffCanvas
          header="DEVICE CYCLE"
          isOpen={isDeviceLifeCycleModalOpen}
          handleClose={handleDevicesCycleClose}
        >
          <DeviceLifeCycle
            handleClose={handleDevicesCycleClose}
          />
        </VWOffCanvas>
        <VWModel
          header="DEVICE LOG"
          isOpen={isDeviceLogModalOpen}
          modalSize='extra-large'
          handleClose={handleDevicesLogClose}
        >
          <DevicleLog
            handleClose={handleDevicesLogClose}
          />
        </VWModel>
      </div >
    </React.Fragment >
  )
}

const mapStateToProps = (state) => ({
  isCreateDeviceModalOpen: state.device.isCreateDeviceModalOpen,
  isAssignDeviceModalOpen: state.device.isAssignDeviceModalOpen,
  errorMessage: state.device.deviceListErrorMsg,
  deviceList: state.device.devices,
  totalRecordsCount: state.device.totalDeviceRecordsCount,
  isGetDevicePending: state.device.isGetDevicePending,
  isAssignSuccess: state.device.isAssignSuccess,
  deviceDeleteErrorMessage: state.device.deviceDeleteErrorMessage,
  currentProfile: state.login.currentProfile,
  //---------------------DEVICE LIFE CYCLE---------------------------
  isDeviceLifeCycleModalOpen: state.device.isDeviceLifeCycleModalOpen,
  //---------------------DEVICE LOG----------------------------------
  isDeviceLogModalOpen: state.device.isDeviceLogModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
  openCreateDeviceModal: () => dispatch(openCreateDeviceModal()),
  closeCreateDeviceModal: () => dispatch(closeCreateDeviceModal()),
  openAssignDeviceModal: () => dispatch(openAssignDeviceModal()),
  closeAssignDeviceModal: () => dispatch(closeAssignDeviceModal()),
  getDevicesList: (currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion,
    searchOrgName, searchAssignedByUserEmail, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive,
    searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => dispatch(getDevicesList(currentPage,
      pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedByUserEmail,
      searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail,
      searchroomName, searchCreatedDateTime, sortDirection, sortOrder)),
  getLatestDevices: (currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion,
    searchOrgName, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName,
    searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => dispatch(getLatestDevices(currentPage, pagesize,
      searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedUserDisplayName,
      searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName,
      searchCreatedDateTime, sortDirection, sortOrder)),
  exportData: () => dispatch(exportData()),
  clearDeviceListError: () => dispatch(clearDeviceListError()),
  exportLatestDevices: () => dispatch(exportLatestDevices()),
  deleteDevice: (devices) => dispatch(deleteDevice(devices)),
  deviceDeleteError: () => dispatch(deviceDeleteError()),
  //---------------------DEVICE LIFE CYCLE---------------------------
  openDevicesCycleModal: () => dispatch(openDevicesCycleModal()),
  closeDevicesCycleModal: () => dispatch(closeDevicesCycleModal()),
  setDeviceId: (id) => dispatch(setDeviceId(id)),
  //---------------------DEVICE LOG----------------------------------
  setSelectedDevice: (selectedDevice) => dispatch(setSelectedDevice(selectedDevice)),
  openDevicesLogModal: () => dispatch(openDevicesLogModal()),
  closeDevicesLogModal: () => dispatch(closeDevicesLogModal()),

});


export default connect(mapStateToProps, mapDispatchToProps)(DeviceList);